
<script setup>
import { useHead } from '@unhead/vue';
import OgImage from '../../images/blog/got-bag/gotbag-1.png';

useHead({
	"title": "Swagger’s 1% for the Planet Impact in 2025",
	"meta": [
		{
			"name": "description",
			"content": "Swagger’s 1% for the Planet commitment in 2025. Learn about the nonprofits we’re supporting and how we’re contributing to a more sustainable future."
		},
		{
			"rel": "canonical",
			"href": "https://giveswagger.com/swagger-brands-we-love-got-bag"
		},
		{
			"property": "og:title",
			"content": "Swagger’s 1% for the Planet Impact in 2025"
		},
		{
			"property": "og:description",
			"content": "Swagger’s 1% for the Planet commitment in 2025. Learn about the nonprofits we’re supporting and how we’re contributing to a more sustainable future."
		},
		{
			"property": "og:url",
			"content": "https://giveswagger.com/swagger-brands-we-love-got-bag"
		},
		{
			"property": "og:image",
			"content": `https://giveswagger.com${OgImage}`
		}
	]
});
</script>
<template lang="pug">

article.page.page--simple
	header.page__header
		h1 
	.page__content
		section.section
			.section__content
				.featured
					img(src='../../images/blog/got-bag/gotbag-1.png' alt="GOT BAG ocean-plastic backpack seen along a polluted coastal landscape, symbolizing the powerful intersection of innovation and environmental impact.")
				p At Swagger, we’re drawn to brands that don’t just make noise—they make change. GOT BAG is exactly that kind of brand. Born from a bold idea and built on a better future, this German company transforms ocean plastic into sleek, durable backpacks and accessories that are as stylish as they are sustainable.

				p Their impact? Real, measurable, and growing by the day. And we’re here for all of it.

				h2 A Brand with a Mission (and a Plan)
				img(src='../../images/blog/got-bag/gotbag-2.png')
				p In 2016, GOT BAG launched with one radical goal: <b>to clean up our oceans and give plastic waste a new purpose</b>. The result was the world’s first backpack made with ocean plastic—and an entire movement in sustainable design.
				p But this isn’t just about bags. It’s about creating a closed loop that starts with plastic collected by their <b>own clean-up program in Indonesia</b>, where ocean pollution is among the highest in the world. Local communities are employed to recover the plastic, which is sorted, processed, and transformed into <B>Ocean Impact Plastic</b>—a high-performance material used in every product.
				p Every element of GOT BAG’s process is intentional. From product design and manufacturing to repairs and end-of-life recycling, their circular approach ensures nothing goes to waste and every story has a second chapter.

				h2 Why GOT BAG Stands Out
				img(src='../../images/blog/got-bag/gotbag-3.png')
				p This isn’t sustainability as a slogan—it’s a full-on commitment to doing better, every step of the way.
				ul
					li <b>Over 1,000 tons</b> of ocean plastic collected (and counting)
					li Clean-up teams provided with fair wages, safe conditions, and community support
					li Full transparency and circular design—from first use to final recycling

				p Plus, when a product gets worn down, GOT BAG doesn’t toss it—they <b>repair it or recycle it</b>, helping customers stay part of the solution long after their first use.

				h2 Minimalism Meets Meaning
				img(src='../../images/blog/got-bag/gotbag-4.png')
				p GOT BAG’s design language is as clean as their mission: minimalist silhouettes, water-resistant materials, and purposeful functionality. These bags are built to endure the daily grind—and the elements—with a timeless aesthetic that speaks volumes.
				p
					b Product Highlights Include:
				ul
					li Rolltop backpacks for sleek, adaptable storage
					li Daypacks and commuter sleeves for everyday carry
					li Functional pouches and wallets made with impact in mind.
					li Travel accessories designed with movement, not waste.
				p Every piece is made for customization, making GOT BAG perfect for <b>eco-conscious corporate gifting</b>, employee onboarding, or events that value planet over plastic.

				h2 Why We Love It at Swagger
				img(src='../../images/blog/got-bag/gotbag-5.png')
				p We believe branded merch should do more than look good—it should mean something. That’s why we’re so proud to partner with GOT BAG. Their approach to <b>ethical production, community empowerment, and climate action</b> aligns perfectly with ours.

				p Choosing GOT BAG means choosing a product that tells a deeper story. It’s a gift your team or clients will be proud to carry—because it’s not just a bag. It’s a bold stand for the planet.

				p Ready to turn your swag into something truly impactful? With GOT BAG on board, we’ll help you create a branded gift that speaks volumes—and <b>actually helps clean up the ocean</b> while you’re at it. Just fill out this short form: <router-link to="/get-started">Let’s Do This!</router-link>

				p We’d love to hear from you! Drop us a note anytime at <a href="mailto:hello@giveswagger.com">hello@giveswagger.com</a>

				
</template>
  